<div class="content">
  <h2>{{screen.id}}</h2>
  <span>
    {{screen.description}}
  </span>
</div>